import React, {PureComponent} from 'react';
import styled from 'styled-components';

const Icon = styled.div`
  ${({iconImage, color}) => color ?
    `
      background-color: ${color};
    ` : `
      background-image: url(${iconImage});
    `
  }
  background-size: cover;
  width: 45px;
  height: 45px;
  ${({ iconRight }) => iconRight ?
    `
      margin-left: 10px;
    ` : `
      margin-right: 10px;
    `
  }
  flex-shrink: 0;
  ${({ rounded }) => rounded ? `
    border-radius: 100px;
  ` : ''}
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-grow: 7;
  overflow: hidden;
`;

const FlexItem = styled.div`
  flex-grow: 10;
  text-align: left;
  overflow: hidden;
`;

const Label = styled.p`
  font-size: 17px;
  margin: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SubLabel = styled.p`
  font-size: 14px;
  margin: 0px;
  color: grey;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const getValidURL = (url) => {
  try {
    return new URL(url).toString();
  } catch(err) {
    return null;
  }
};

export default class extends PureComponent {
  renderIcon() {
    const {
      icon,
      iconColor,
      rounded,
      iconRight
    } = this.props;

    const iconProps = {
      rounded,
      iconRight
    };

    if (iconColor) {
      iconProps.color = iconColor;
    } else if (icon) {
      iconProps.iconImage = getValidURL(icon);
    } else {
      return;
    }

    return <Icon {...iconProps} />;
  }

  render() {
    const { label, sublabel, iconRight, ...props } = this.props;

    return (
      <FlexContainer {...props}>
        {!iconRight && this.renderIcon()}
        <FlexItem>
          <Label>{label}</Label>
          <SubLabel>{sublabel}</SubLabel>
        </FlexItem>
        {iconRight && this.renderIcon()}
      </FlexContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/text-image-row.js